import React, { FC } from 'react';
import styled from 'styled-components';
import arrowRightIcon from '../../../icons/ic_arrow_right.svg';
import { Link } from 'components/Common';
import Icon from 'components/v2/Icon';
import { fontSemibold } from '../../../themes';

const ActionContainer = styled.div<any>`
  position: relative;
  display: flex;
  align-items: center;

  height: 65px;
  padding-right: 16px;

  border-bottom: ${({theme}) => `1px solid ${theme.borderColorV2}`};
`;

const ActionTitle = styled.span<any>`
  flex: 1;
  margin-left: 16px;
  
  font-size: 16px;
  line-height: 20px;
  color: ${({ color }) => color};
  font-family: ${fontSemibold};
`;

interface LinkActionProps {
  id: string;
  onClick?: (event: any) => void;
  text?: string;
  to?: string;
  pagedirection?: string;
  textColor?: string;
  arrow: boolean;
  last?: boolean;
}

export const LinkAction: FC<LinkActionProps> = ({
  id,
  text,
  textColor,
  arrow,
  onClick,
  to,
}) => {
  const container = (
    <ActionContainer onClick={onClick} id={id} aria-label={id}>
      <ActionTitle color={textColor}>
        {text}
      </ActionTitle>
      {arrow && <Icon url={arrowRightIcon} width={20} height={20}/>}
    </ActionContainer>
  );

  if (to) {
    return (
      <Link
        to={to}
        pageDirection='FORWARD'
        id={id}
        aria-label={id}
      >
        {container}
      </Link>
    );
  }

  return container;
};

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  border-top: 1px solid ${({ theme }) => theme.borderColorV2};
`;
